import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/AddButton";
import { edit, Plus, map, placeMareker, truck } from "../../../common/svg";
import { TripDetails } from "../../../common/staticData";
import CustomCard from "../../../components/Card";
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomChip from "../../../components/Chip";
import DeliveryTimeline from "../../../components/DeliveryTimeline";
import BookingDetails from "../../../components/Vehicle/index";
import VehicleStats from "../../../components/Vehicle/speed";
import ShippingFlow from "../../../components/TrackingStatus/Track";
import TransportTracker from "../view/components/TransportTracker";
import Vehicleroute from "../../../components/Vehicle/route";
import SecureImage from "../../../components/BucketImage/Image";
import { ApiService } from "../../../service/api.service";
import { OPERTIONS_URL, MASTER_URL } from "../../../common/common";
// NEW MAP COMPONENT - SIMPLIFIED VERSION
import SimpleTripMap from "../../../components/TripMap/SimpleTripMap";

const Vehicles = ({ id, tripData, vehicleAssignments }: any) => {
  const apiService = new ApiService();
  const [activeTripCard, setActiveTripCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [isWhite, setIsWhite] = useState(false);

  // NEW STATE FOR TRACKING URL AND VEHICLE DATA
  const [trackingUrl, setTrackingUrl] = useState<string | undefined>(undefined);
  const [vehicleData, setVehicleData] = useState<any>(null);

  // MAP DISPLAY STATE - SAME AS TRIPS PAGE
  const [isBlurred, setIsBlurred] = useState(true);

  useEffect(() => {
    const handleClick = () => setIsWhite(true);
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const handleClick = () => {
    console.log("Button clicked!");
  };

  const handleViewDetails = (index: number) => {
    setActiveTripCard(index);
    setViewTripDetails(true);
  };

  const [isEditing, setIsEditing] = useState(false);
  const [routeInfo, setRouteInfo] = useState({
    code: "",
    start: "",
    end: "",
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const parts = value.split(" – "); // Split input by " – "

    if (parts.length === 3) {
      setRouteInfo({
        code: parts[0],
        start: parts[1],
        end: parts[2],
      });
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const ShowMap = async () => {
    try {
      console.log("🗺️ Showing map with SimpleTripMap component");
      setIsBlurred(false);

      // Try to start tracking if we have vehicle registration number, but don't block map display
      const currentVehicleAssignments = vehicleAssignments || tripData?.vehicleAssignments || [];
      const vehicleRegNo = currentVehicleAssignments?.[0]?.vechicleData?.vehicleRegNo;
      if (vehicleRegNo) {
        console.log("🚗 Starting tracking for vehicle:", vehicleRegNo);
        // Note: We don't have useLiveTracking hook here, so we'll just show the map
      } else {
        console.log("⚠️ No vehicle registration number found, but showing map anyway");
      }
    } catch (error) {
      console.error("❌ Error starting live tracking:", error);
      // Still show the map even if tracking fails
      setIsBlurred(false);
    }
  };

  useEffect(() => {
    // Use props data if available, otherwise use vehicle assignments from trip data
    if (vehicleAssignments && vehicleAssignments.length > 0) {
      console.log("Using vehicle assignments from props:", vehicleAssignments);
    } else if (tripData?.vehicleAssignments && tripData.vehicleAssignments.length > 0) {
      console.log("Using vehicle assignments from trip data:", tripData.vehicleAssignments);
    }
  }, [vehicleAssignments, tripData]);

  // NEW: Fetch vehicle details with tracking URL from master data service
  useEffect(() => {
    const fetchVehicleDetails = async () => {
      const currentVehicleAssignments = vehicleAssignments || tripData?.vehicleAssignments || [];
      if (currentVehicleAssignments.length > 0) {
        const vehicleId = currentVehicleAssignments[0]?.vehicleId;
        if (vehicleId) {
          console.log("🔍 Fetching vehicle details for vehicleId:", vehicleId);
          try {
            console.log("🔍 Making API call to:", `${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
            const vehicleResponse: any = await apiService.getApi(`${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
            console.log("🔍 Vehicle API response:", vehicleResponse);
            console.log("🔍 Vehicle API response status:", vehicleResponse?.status);
            console.log("🔍 Vehicle API response type:", typeof vehicleResponse?.status);

            if (vehicleResponse?.status === 200 || vehicleResponse?.status === "200") {
              console.log("🔍 Inside status 200 condition");
              console.log("🔍 Vehicle response body:", vehicleResponse.body);
              const vehicleTrackingUrl = vehicleResponse.body?.trackingUrl;
              console.log("🔍 Vehicle trackingUrl:", vehicleTrackingUrl);
              console.log("🔍 Vehicle trackingUrl type:", typeof vehicleTrackingUrl);
              setTrackingUrl(vehicleTrackingUrl);
              setVehicleData(vehicleResponse.body);
            } else {
              console.log("🔍 Vehicle API response status is not 200:", vehicleResponse?.status);
            }
          } catch (vehicleError) {
            console.error("❌ Error fetching vehicle details:", vehicleError);
          }
        }
      }
    };

    const currentVehicleAssignments = vehicleAssignments || tripData?.vehicleAssignments || [];
    if (currentVehicleAssignments.length > 0) {
      fetchVehicleDetails();
    }
  }, [vehicleAssignments, tripData]);

  return (
    <div>
      <div className="bg-white p-2 mt-3 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className="text-[#282828] text-[16px] font-[600]">Route Points</p>
          <CustomButton label="" icon={Plus} onClick={handleClick} />
        </div>
        <br />
        <div className="flex gap-2 mt-">
          {/* Left */}
          <div>
            {(vehicleAssignments || tripData?.vehicleAssignments || []).map((vehicle: any, index: number) => (
              <CustomCard
                key={index}
                onClick={() => handleViewDetails(index)}
                isActive={activeTripCard === index}
                className="w-[400px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded mb-4"
              >
                <div className="gap-[-1]">
                  {/* Top Section: Vehicle Name and Status */}
                  <div className="flex justify-between items-center">
                    <div className="flex items-center space-x-2">
                      <p className="font-semibold">{vehicle?.vechicleData?.vehicleRegNo || 'TN 73A 0603'}</p>
                      <CustomChip
                        text={index === 0 ? "Ongoing" : "Completed"}
                        textColor={index === 0 ? "#FF973C" : "#04D900"}
                        backgroundColor={index === 0 ? "#FFF5EC" : "#ECFFEB"}
                        borderColor={index === 0 ? "#FF973C" : "#04D900"}
                      />
                    </div>
                    <p className="font-[400] text-[14px]">#{String(index + 1).padStart(2, '0')}</p>
                  </div>

                  {/* Vehicle Details */}
                  <div className="flex justify-between">
                    <div className="leading-[18px] flex flex-col items-start">
                      <div className="flex items-center mt-2">
                        <span>{index === 0 ? "Empty to Warehouse" : "Warehouse to Port"}</span>
                        <span className="ml-5 font-medium">{tripData?.tripName || 'Trip Name'}</span>
                      </div>

                      <p className="font-poppins font-normal italic text-[15px] mt-1">
                        {tripData?.startingDateTime ? new Date(tripData.startingDateTime).toLocaleString() : '30 July 2024, 06:16pm'}
                      </p>
                    </div>
                    <div className="flex items-center flex-col justify-center">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg ${index === 0 ? 'bg-orange-500' : 'bg-green-500'
                        }`}>
                        {tripData?.daysLeft || 3}
                      </div>
                      <p className="text-[14px] font-[400]">
                        {index === 0 ? 'Days Running' : 'Total Days'}
                      </p>
                    </div>
                  </div>

                  {/* Vehicle Type and Location */}
                  <div className="flex justify-between items-end">
                    <div className="flex flex-col leading-[15px]">
                      <p className="text-[14px]">Transporter</p>
                      <p className="font-medium text-[14px]">Transporter Name</p>
                    </div>
                    <div className="leading-[15px]">
                      <p className="text-[14px] ml-4 font-[300]">Total 10065 Kms</p>
                      <p className="text-[16px] ml-6 text-[#F7941D] font-[600] flex items-center">
                        Chennai
                        <div className="text-[#F7941D] w-[25px] h-[25px]">
                          <SecureImage
                            fileKey={placeMareker}
                            alt="header icon"
                            width="25px"
                            className="w-full h-full"
                          />
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </CustomCard>
            ))}
          </div>
          {viewTripDetails && (
            <div className="mt-[-20px] p-4 flex-1 border-l border-[#C1C1C1] border-dashed overflow-hidden">
              <div className="flex flex-col w-full max-w-full">
                <div className="flex items-center space-x-2 flex-wrap">
                  <SecureImage fileKey={truck} alt="header icon" width="89px" />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2 leading-[-15px]">
                      <p className="text-[#444FBD] text-[14px] font-[600]">
                        Trip Name
                      </p>
                      <CustomChip
                        text="Waiting for clearance"
                        textColor="#FF973C"
                        backgroundColor="#FFF5EC"
                        borderColor="#FF973C"
                      />
                    </div>
                    <p className="text-[14px] font-[400]">Z99335T</p>
                    <p className="text-[14px] font-[400]">
                      30 July 2024, 06:16pm
                    </p>
                  </div>
                  <div className="flex flex-col items-end">
                    <div className="flex items-center">
                      <DaysLeftCounter totalDays={5} />
                      <p className="text-[14px] font-[400]">Days left</p>
                    </div>
                    <p className="text-[14px]">30 July 2024, 06:16pm</p>
                  </div>
                </div>
                <BookingDetails />
                <br />
                <br />
                <TransportTracker />
                <ShippingFlow />
                <br />
                <VehicleStats />
                <div className="p-2 flex flex-col gap-4">
                  <div className="flex items-center justify-between p-2 w-full flex-wrap gap-2">
                    <p className="text-gray-700 text-sm font-medium">
                      Route 1
                    </p>
                    <div className="border border-gray-300 rounded-lg px-4 py-2 flex-1 min-w-0 max-w-md">
                      {isEditing ? (
                        <input
                          type="text"
                          name="route"
                          value={`${routeInfo.code} – ${routeInfo.start} – ${routeInfo.end}`}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          className="text-black text-sm font-semibold w-full bg-transparent outline-none"
                          autoFocus
                        />
                      ) : (
                        <p className="text-black text-sm font-semibold">
                          <span className="font-bold">{routeInfo.code}</span> –{" "}
                          <span className="font-medium">{routeInfo.start}</span>{" "}
                          – <span className="font-medium">{routeInfo.end}</span>
                        </p>
                      )}
                    </div>
                    <CustomButton
                      label=""
                      icon={edit}
                      onClick={handleEditClick}
                    />
                  </div>
                </div>
                <div className="flex items-start gap-4 flex-wrap">
                  <DeliveryTimeline />
                  <div className="flex-1 min-w-0 max-w-md h-[500px] rounded-[20px] mt-10 gap-5">
                    <Vehicleroute />
                    <br />
                    {/* MAP - UPDATED WITH SAME PATTERN AS TRIPS PAGE */}
                    {!isBlurred ? (
                      <div className="w-full h-full">
                        {/* NEW MAP COMPONENT - SIMPLIFIED VERSION */}
                        <SimpleTripMap
                          tripId={id}
                          showMap={true}
                          onMapReady={() => console.log("🗺️ Vehicle map is ready")}
                          trackingUrl={trackingUrl}
                        />
                      </div>
                    ) : (
                      <div
                        className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-500 text-2xl font-semibold cursor-pointer"
                        onClick={ShowMap}
                      >
                        Show Live Map
                      </div>
                    )}
                    <br />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Vehicles;